const moduleoptioncoursetypes = {
	title: "Module Option - Course Type",
	new_moduleoptioncoursetype: "New Module Option - Course Type",
	edit_moduleoptioncoursetype: "Edit Module Option - Course Type: {name}",
	id: "ID",
	moduleoption_id: "Module Option",
	coursetype_id: "Course Type",
	coursetypegroup_id: "Course Type Main Group",
	name: "Name",
	price: "Price",
	comment: "Comment",
};
export default moduleoptioncoursetypes;